
export const Data = [
  {
    type:"zh",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/news/banner.jpg"
      },
      itemData:{
        text1:{
          type:"text",
          content:"新闻公告"
        },
        text2:{
          type:"text",
          content:"关注我们的最新动态"
        },
        news:[[
          {
            path:{
              type:"text",
              content:"ljrc"
            },
            text1:{
              type:"text",
              content:"2024年9月11日"
            },
            text2:{
              type:"text",
              content:"双项领军人才计划加持，牙客邦口腔Er:YAG激光治疗仪引领口腔治疗新风潮！"
            },
            img:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/news/ljrw.png"
            }
          },
          {
            path:{
              type:"text",
              content:"db"
            },
            text1:{
              type:"text",
              content:"2024年3月20日"
            },
            text2:{
              type:"text",
              content:"2024年东北国际口腔展隆重开幕，微创未来邀请您相约沈阳！"
            },
            img:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/news/db.jpg"
            }
          },
          {
            path:{
              type:"text",
              content:"xb"
            },
            text1:{
              type:"text",
              content:"2024年04月08日"
            },
            text2:{
              type:"text",
              content:"喜报！国内口腔Er:YAG激光治疗仪获批，成功填补国内该领域空白"
            },
            img:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/hh/item4.jpg"
            }
          }
        ],[
          {
            path:{
              type:"text",
              content:"jxll"
            },
            text1:{
              type:"text",
              content:"2024年06月28日"
            },
            text2:{
              type:"text",
              content:"惊喜连连！铒激光惊艳亮相苏州口腔种植大会"
            },
            img:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/hh/item3.jpg"
            }
          }
        ]]
      }






    }

  },
  {
    type:"en",
    text1:"英文"
  }
];



// WEBPACK FOOTER //
// ./src/components/js/news.js